import * as React from 'react'
import {Button} from '@frontrow/console/src/components/button'

type Props = {
  createDemoDistrict: () => void
}

export default function NotRequestedPanel(props: Props): React.ReactElement {
  const {createDemoDistrict} = props

  return (
    <React.Fragment>
      <p>Your demo district: None</p>
      <Button onClick={createDemoDistrict} dataTest="request-demo-button">
        Request a demo
      </Button>
    </React.Fragment>
  )
}
